<script setup>
import { useSettingsStore } from '../stores/settings';

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

// Get the settings store
const settingsStore = useSettingsStore();

const decodeHtml = (html) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
};
</script>

<template>
  <!-- START: Integrations -->
  <section class="dataagent-settings-section da:mb-5 da:p-5">
    <div class="da:grid da:grid-cols-3 da:gap-4 da:justify-items-start">
      <!-- Integration Cards -->
      <div
        v-for="(integration, integrationId) in settingsStore.integrations"
        :key="integrationId"
        class="da:border-2 da:border-[#eee] da:rounded-md da:p-4 da:bg-[#fafafa] da:transition-all da:duration-300 da:ease-in-out da:hover:shadow-md da:max-w-md"
      >
        <div class="da:flex da:items-start">
          <div class="da:flex-1">
            <div class="da:flex da:items-center">
              <div
                class="da:w-12 da:h-12 da:flex da:items-center da:justify-center da:bg-[#f0f0f0] da:rounded-full da:overflow-hidden da:mr-2"
              >
                <img :src="integration.icon" :alt="integration.name" class="da:w-full da:h-full da:object-cover" />
              </div>
              <h3 class="da:text-base da:font-medium da:mb-1">{{ integration.name }}</h3>
            </div>

            <p class="da:text-sm da:text-gray-600 da:mb-3">{{ integration.description }}</p>

            <!-- Status Badge and Action Buttons -->
            <div class="da:mb-3 da:flex da:items-center da:justify-between">
              <div>
                <span
                  v-if="integration.is_active"
                  class="da:inline-flex da:items-center da:px-2.5 da:py-0.5 da:rounded-full da:text-xs da:font-medium da:bg-green-100 da:text-green-800"
                >
                  <span class="da:w-2 da:h-2 da:mr-1.5 da:bg-green-500 da:rounded-full"></span>
                  {{ labels.active }}
                </span>
                <span
                  v-else
                  class="da:inline-flex da:items-center da:px-2.5 da:py-0.5 da:rounded-full da:text-xs da:font-medium da:bg-gray-100 da:text-gray-800"
                >
                  <span class="da:w-2 da:h-2 da:mr-1.5 da:bg-gray-500 da:rounded-full"></span>
                  {{ labels.inactive }}
                </span>
              </div>

              <!-- Action Buttons -->
              <div class="da:flex da:space-x-2">
                <!-- If not active but installed, show Activate button with WordPress nonce URL -->
                <a
                  v-if="integration.is_installed && !integration.is_active"
                  :href="decodeHtml(integration.activate_url)"
                  class="button da:inline-flex da:items-center da:px-3 da:py-1.5 da:border da:border-transparent da:text-xs da:font-medium da:rounded da:shadow-sm da:bg-[#4CB21A] da:hover:bg-[#3a9115] da:focus:outline-none da:focus:ring-2 da:focus:ring-offset-2 da:focus:ring-[#4CB21A]"
                >
                  {{ labels.connect }}
                </a>
                <!-- If not installed, show Install button -->
                <a
                  v-if="!integration.is_installed"
                  :href="integration.install_url"
                  class="button da:inline-flex da:items-center da:px-3 da:py-1.5 da:border da:border-[#d3d3d3] da:text-xs da:font-medium da:rounded da:shadow-sm da:text-gray-700 da:bg-white da:hover:bg-gray-50 da:focus:outline-none da:focus:ring-2 da:focus:ring-offset-2 da:focus:ring-gray-500"
                >
                  {{ labels.install }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
